import lepaya from '@/http/lepaya'

export default {
  fetchZoomMeetingStartUrl (journeyId, companyCode, classroomId) {
    return lepaya.get(`/companies/${companyCode}/journeys/${journeyId}/events/${classroomId}/meeting-start-url`)
  }
}
